import React from 'react'
import cx from 'classnames'
import parse from 'html-react-parser'
import domToReact from 'html-react-parser/lib/dom-to-react'
import { camelCase, trim } from 'libraries/lodash'
import { ExternalLink } from 'react-external-link'
import SmartFcCrossReferenceLinkContainer from 'redux/containers/components/SmartFcCrossReferenceLinkContainer'
import SmartFcFaqReferenceLinkContainer from 'redux/containers/components/SmartFcFaqReferenceLinkContainer'

export const styleStringToObject = (style) => {
  const trimmed = trim(style)

  return (
    trimmed.split(';').filter(s => s.length)
      .reduce((a, b) => {
        const keyValue = b.split(':')
        a[camelCase(keyValue[0])] = trim(keyValue[1])
        return a
      }, {})
  )
}

const options = {
  replace: (domNode) => {
    const { attribs, name, children } = domNode

    if (attribs && attribs.class === 'fc-cross-reference') {
      return (
        <SmartFcCrossReferenceLinkContainer href={attribs.href}>
          {domToReact(children)}
        </SmartFcCrossReferenceLinkContainer>
      )
    }

    if (attribs && attribs.class === 'fc-faq-anchor') {
      return (
        <SmartFcFaqReferenceLinkContainer {...{ attribs }}>
          {domToReact(children)}
        </SmartFcFaqReferenceLinkContainer>
      )
    }
    const styleObj = attribs && styleStringToObject(attribs.style)

    switch (name) {
      case 'head':
      case 'body':
        return (
          <div>
            {domToReact(children, options)}
          </div>
        )
      case 'table':
        return (
          React.createElement(
            'table',
            { style: { ...styleObj, width: '100%' } },
            domToReact(children, { trim: true, ...options })
          )
        )
      case 'externallink':
        return (
          <ExternalLink href={attribs.href} className={cx(attribs.class, 'hover-underline')}>
            {domToReact(children, options)}
          </ExternalLink>
        )
      default:
        return null
    }
  }
}

export const parseHtmlContent = (dirtyHtml) => parse(dirtyHtml, options)
